export interface IpqsRiskContext {
  deviceId?: string;
  deviceFraudChance?: number;
  deviceRequestId?: string;
  deviceGuid?: string;
  internalDeviceId?: string;
  internalDeviceConfidence?: number;
}

const STORAGE_KEY = 'ipqs-risk-context';

export function getIpqsRiskContext(): IpqsRiskContext {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as IpqsRiskContext;
    return {
      deviceId: parsed.deviceId,
      deviceRequestId: parsed.deviceRequestId,
      deviceGuid: parsed.deviceGuid,
      internalDeviceId: parsed.internalDeviceId,
      deviceFraudChance:
        typeof parsed.deviceFraudChance === 'number' && Number.isFinite(parsed.deviceFraudChance)
          ? parsed.deviceFraudChance
          : undefined,
      internalDeviceConfidence:
        typeof parsed.internalDeviceConfidence === 'number' && Number.isFinite(parsed.internalDeviceConfidence)
          ? parsed.internalDeviceConfidence
          : undefined,
    };
  } catch {
    return {};
  }
}

export function setIpqsRiskContext(context: IpqsRiskContext): void {
  const current = getIpqsRiskContext();
  const merged: IpqsRiskContext = {
    deviceId: context.deviceId ?? current.deviceId,
    deviceRequestId: context.deviceRequestId ?? current.deviceRequestId,
    deviceGuid: context.deviceGuid ?? current.deviceGuid,
    deviceFraudChance: context.deviceFraudChance ?? current.deviceFraudChance,
    internalDeviceId: context.internalDeviceId ?? current.internalDeviceId,
    internalDeviceConfidence: context.internalDeviceConfidence ?? current.internalDeviceConfidence,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
}
